// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2344 ? "46bdacfb" : chunkId) + "." + {"1189":"717c9f11ac02f5e9","2344":"87889328a728c581","8964":"74ac824aa57e9880","9651":"9f2fc892289dda5f"}[chunkId] + ".js";
};